import type { partPriceHistory } from "@/api/breakdownService";
import { Box, Typography } from "@mui/material";
import { DataGrid, type GridColDef } from "@mui/x-data-grid";

interface PartPriceHistoryTableProps {
  rows: partPriceHistory[];
}

const PartPriceHistoryTable = ({ rows }: PartPriceHistoryTableProps) => {
  const columns: GridColDef<partPriceHistory>[] = [
    {
      field: "year",
      headerName: "Year",
      align: "right",
      headerAlign: "right",
      flex: 1,
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "right",
            height: "100%",
          }}
        >
          <Typography
            fontSize="0.9rem"
            align="right"
          >
            {params.value}
          </Typography>
        </Box>
      ),
    },
    {
      field: "quarter",
      headerName: "Quarter",
      align: "right",
      headerAlign: "right",
      flex: 1,
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "right",
            height: "100%",
          }}
        >
          <Typography
            fontSize="0.9rem"
            align="right"
          >
            {params.value}
          </Typography>
        </Box>
      ),
    },
    {
      field: "oem_price",
      headerName: "OEM Price",
      align: "right",
      headerAlign: "right",
      flex: 2,
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "right",
            height: "100%",
          }}
        >
          <Typography
            fontSize="0.9rem"
            align="right"
          >
            {params.value}
          </Typography>
        </Box>
      ),
    },
    {
      field: "spare_price",
      headerName: "Spare Price",
      align: "right",
      headerAlign: "right",
      flex: 2,
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "right",
            height: "100%",
          }}
        >
          <Typography
            fontSize="0.9rem"
            align="right"
          >
            {params.value}
          </Typography>
        </Box>
      ),
    },
    {
      field: "oem_diff",
      headerName: "Difference (OEM)",
      align: "right",
      headerAlign: "right",
      flex: 2,
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "right",
            height: "100%",
          }}
        >
          <Typography
            color={
              params.value === 0 ? "black" : params.value > 0 ? "red" : "green"
            }
            fontSize="0.9rem"
            align="right"
          >
            {params.value}
          </Typography>
        </Box>
      ),
    },
    {
      field: "spare_diff",
      headerName: "Difference (Spare)",
      align: "right",
      headerAlign: "right",
      flex: 2,
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "right",
            height: "100%",
          }}
        >
          <Typography
            color={
              params.value === 0 ? "black" : params.value > 0 ? "red" : "green"
            }
            fontSize="0.9rem"
            align="right"
          >
            {params.value}
          </Typography>
        </Box>
      ),
    },
  ];

  return (
    <Box sx={{ width: "100%", mt: 2 }}>
      <DataGrid
        columns={columns}
        rows={rows}
        getRowId={(row: partPriceHistory) => row.id}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
        pageSizeOptions={[10, 20, 50, 100]}
        disableRowSelectionOnClick
        disableColumnSelector
        disableColumnFilter
        disableColumnMenu
        sx={{
          maxHeight: "70vh",
          overflow: "auto",
        }}
      />
    </Box>
  );
};

export default PartPriceHistoryTable;
